var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-login-consumer"},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("系统加载中...")])])}]

export { render, staticRenderFns }